import React, { useEffect } from 'react'
import { AppRoutes } from './routes'
import TagManager from 'react-gtm-module'

type Props = {
  config: {
    gtmTag: string | null
    tenant: {
      name: string
      maxAppointmentWeek: number
      privacyPolicyLink: string
    }
    businessHour: {
      start: number
      end: number
    }
  }
}

export const App: React.FC<Props> = (props) => {
  const { config } = props

  useEffect(() => {
    if (config.gtmTag) {
      TagManager.initialize({ gtmId: config.gtmTag })
    }
  }, []) // eslint-disable-line react-app/react-hooks/exhaustive-deps

  return <AppRoutes config={config} />
}
